import React, { FC, Fragment } from 'react'
import Skeleton from 'react-loading-skeleton';
import useClient from '~/hooks/useClient';

interface PromotionBannerProps {
    data?: any;
}

const PromotionBanner: FC<PromotionBannerProps> = ({ data }) => {

    return data?.content ? (
        <Fragment>
            <div className='!mt-0' dangerouslySetInnerHTML={{
                __html: data?.content
            }}></div>
        </Fragment>

    ) : <></>
}

export default PromotionBanner;
